export default "__VITE_ASSET__02e5c5b4__"